import React from 'react';

// ---------------------------------------------------------------------
// BUTTONDOWN CONFIG
// ---------------------------------------------------------------------
const BUTTONDOWN_USERNAME = 'FPG';
const BUTTONDOWN_EMBED_URL = `https://buttondown.com/api/emails/embed-subscribe/${BUTTONDOWN_USERNAME}`;

/**
 * Drop-in replacement for a CTA button/link — renders an email input +
 * submit button that posts straight to Buttondown. This is a plain HTML
 * form POST (Buttondown's own embed markup, just re-styled), so there's
 * no API key and no backend involved — the browser submits it directly.
 *
 * Usage:
 *   <NewsletterSignup buttonStyle={styles.ctaButton} />
 * Pass your existing style objects in as props so this visually matches
 * whatever button it's replacing, instead of needing its own hardcoded
 * colors. Only buttonStyle is required to look "right" — the others
 * have reasonable dark-theme defaults if you don't pass them.
 */
const NewsletterSignup = ({
  buttonStyle,
  inputStyle,
  wrapperStyle,
  buttonLabel = 'Sign up for our Newsletter!',
  placeholder = 'you@example.com',
}) => {
  return (
    <form
      action={BUTTONDOWN_EMBED_URL}
      method="post"
      target="_blank" // opens Buttondown's "you're subscribed" confirmation in a new tab, keeps them on your site
      style={{
        display: 'flex',
        gap: '10px',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        ...wrapperStyle,
      }}
    >
      <input
        type="email"
        name="email"
        required
        placeholder={placeholder}
        style={{
          padding: '12px 16px',
          borderRadius: '8px',
          border: '1px solid #2d3748',
          background: '#0f1a30',
          color: '#e2e8f0',
          fontSize: '15px',
          minWidth: '220px',
          ...inputStyle,
        }}
      />
      <button
        type="submit"
        style={{
          cursor: 'pointer',
          border: 'none',
          font: 'inherit',
          ...buttonStyle, // spread last so it overrides everything above — matches your existing CTA button exactly
        }}
      >
        {buttonLabel}
      </button>
    </form>
  );
};

export default NewsletterSignup;
